import { render, staticRenderFns } from "./numbers-chart.vue?vue&type=template&id=eb2cd42e&scoped=true&"
import script from "./numbers-chart.vue?vue&type=script&lang=ts&"
export * from "./numbers-chart.vue?vue&type=script&lang=ts&"
import style0 from "./numbers-chart.vue?vue&type=style&index=0&id=eb2cd42e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2cd42e",
  null
  
)

export default component.exports